<mat-accordion class="custom card-body">
    <mat-expansion-panel id="d" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header class="sticky">
            <mat-panel-title>
                <h6 class="session-h ff mb-0">Scrutiny Tab</h6>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="ScrutinyPopForm">
            <div class="col-sm-12 p-0">
                <mat-form-field appearance="outline" class="example-full-width mt-2">
                    <mat-label>
                        Scrutiny
                    </mat-label>
                    <mat-select #select56 class="colorblack" formControlName="Srty" [disabled]="isdisabled">
                        <mat-select-filter *ngIf="select56.focused" [placeholder]="'Filter'" [displayMember]="'CdCode'"
                            [array]="SrtyList" (filteredReturn)="filteredSrtyList =$event">
                        </mat-select-filter>
                        <mat-option *ngFor="let item of filteredSrtyList" [value]="item.CdCode"
                            (click)="Scrutiny(item.CdCode)" (click)="toggleExamDropdown(item)" [disabled]="isOptionDisabled(item.CdCode)">
                            {{item.CdDesc}}
                        </mat-option>
                    </mat-select>

                </mat-form-field>
                <mat-error class="margin_tp sz"
                    *ngIf="ScrutinyPopForm.controls['Srty'].touched && ScrutinyPopForm.controls['Srty'].errors?.required">
                    Mandatory
                </mat-error>
            </div>
            <div class="col-sm-12 p-0">
                <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>Text</mat-label>
                    <!--  -->
                    <textarea matInput formControlName="Text" rows="4" cols="2" placeholder="Enter text"[readonly]="UpdateBtn" [disabled]="isdisabled"></textarea>
                </mat-form-field>
                <mat-error class="margin_tp sz"
                    *ngIf="!UpdateBtn && ScrutinyPopForm.controls['Text'].touched && ScrutinyPopForm.controls['Text'].errors?.required">
                    Mandatory
                </mat-error>
            </div>
            <div *ngIf="showwMessage" class="col-sm-12 col">{{errmessage}}</div>
            
            <div class="col-sm-12 p-0" *ngIf="TabVisible">
                <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>Tabs</mat-label>
                    <mat-select multiple required #select56 class="colorblack" formControlName="Tabs"
                        (selectionChange)="documenthinnedDropdown($event.value)">
                        <mat-option value="Personal Details">Personal Details</mat-option>
                        <mat-option value="Contact Details">Contact Details</mat-option>
                        <mat-option value="Reservations Details">Reservations Details</mat-option>
                        <mat-option value="Additional Details">Additional Details</mat-option>
                        <mat-option value="Qualification Details">Qualification Details</mat-option>
                        <mat-option value="Photo & Signature">Photo & Signature</mat-option>
                        <mat-option value="Admission Details">Admission Details</mat-option>
                        <mat-option value="Document Upload" (click)="TabSelected('Document Upload')">Document Upload</mat-option>
                    </mat-select>
                    
                </mat-form-field>
                <mat-error class="margin_tp sz float-left"
                    *ngIf="ScrutinyPopForm.controls['Tabs'].touched && ScrutinyPopForm.controls['Tabs'].errors?.required">
                    Mandatory
                </mat-error>
            </div>
           
            <div class="col-sm-12 p-0" *ngIf="documentDropdownVisible">
                <mat-form-field appearance="outline" class="example-full-width mt-2">
                    <mat-label>Documents</mat-label>
                    <mat-select multiple #select56 class="colorblack" formControlName="StuSrNo" #select3904>
                        <mat-option *ngFor="let document of documentList" [value]="document.StuSrNo">
                            {{ document.StuDocumentName }}
                        </mat-option>
                    </mat-select>
                    
                </mat-form-field>
                <mat-error class="margin_tp sz"
                    *ngIf="ScrutinyPopForm.controls['StuSrNo'].touched && ScrutinyPopForm.controls['StuSrNo'].errors?.required">
                    Mandatory
                </mat-error>
            </div>
            <div class="row prpl mb-1">
                <div class="col-sm-12">
                    <button type="button" class="btn btn-primary btn-icon-text floatright  mt-1"
                        (click)="openStudentHistoryPopUP()">
                        <span style="display: contents; align-items: center;">
                            <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                            History
                        </span>
                    </button>
                    <!--   -->
                    <button (click)="submit()" type="button" [disabled]="UpdateBtn"
                        class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                        <span style="display: contents; align-items: center;">
                            <img width="20vh" src="../../assets/img/edit.gif" style="margin-right: 5px;">
                            Update
                        </span>
                    </button>

                </div>
            </div>
        </form>
    </mat-expansion-panel>
</mat-accordion>